'use client'

import Image from 'next/image'
import { BsWhatsapp } from 'react-icons/bs'

import { Button } from '@/_components/ui/button'

import {
  Section,
  SectionColumn,
  SectionContent,
  SectionHeader,
  SectionHeaderSubtitle,
  SectionHeaderTitle,
  SectionText,
} from '../_components/section'

export const Showcase = () => {
  return (
    <Section id="home">
      <SectionContent className="gap-11 pb-24 md:py-28">
        <SectionColumn className="text-center md:text-left lg:max-w-[584px] lg:text-left">
          <SectionHeader>
            <SectionHeaderSubtitle>Bem-vindo (a)!</SectionHeaderSubtitle>
            <SectionHeaderTitle className="text-[2rem] leading-9 md:text-[3rem] md:leading-[112%]">
              Sim, agora é possível parcelar cirurgias e exames particulares
            </SectionHeaderTitle>
          </SectionHeader>

          <SectionText className="mt-10 text-lg leading-[1.675rem] md:mt-12 md:text-xl lg:leading-[1.875rem]">
            Realizamos a análise de crédito personalizada para cada paciente da
            sua instituição, pois nosso objetivo é democratizar o acesso à saúde
            de qualidade.
          </SectionText>

          <p className="md:border-brand-grayscale-50 mt-16 font-semibold text-brand-grayscale-12 md:mt-12 md:border-t md:border-solid md:pt-12">
            A solução de pagamento que a saúde dos seus pacientes precisa!
          </p>

          <SectionColumn className="mt-8 gap-4 md:flex-row">
            <a href="https://wa.link/pgv5tw" target="_blank">
              <Button size="lg" className="items-center gap-2">
                <BsWhatsapp size={18} />
                Fale conosco
              </Button>
            </a>
          </SectionColumn>
        </SectionColumn>

        <SectionColumn>
          <Image
            src="/images/showcase-01-mobile.jpeg"
            className="h-auto w-full lg:hidden"
            width={0}
            height={0}
            sizes="100vw"
            alt="Facilitamos o acesso à saúde!"
          />

          <Image
            src="/images/showcase-01-desktop.jpeg"
            className="hidden h-auto w-full lg:block"
            width={0}
            height={0}
            sizes="100vw"
            alt="Facilitamos o acesso à saúde!"
          />
        </SectionColumn>
      </SectionContent>
    </Section>
  )
}
